module.exports = __webpack_public_path__ + "img/17420d42ce1210895dad41d52414d37.png";